<template>
  <v-app id="app">
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App",
};
</script>

<style scoped>
::v-deep .v-menu__content.theme--light.menuable__content__active {
  border-radius: 21px !important;
}
</style>
